import { useEffect, useRef } from "react";
import { useAppSelector } from "../store/index.ts";
import { API_USER } from "../api/user.js";
import { setCurrency, setInfo } from "../store/userSlice.js";
import { useDispatch } from "react-redux";
import { useEventListener, useReadLocalStorage } from "usehooks-ts";
import { ENUM_COMMON_EVENT } from "./common/useListener.js";
import { ENUM_LCS_NAME, ENUM_PROMOTION_STATUS, TEST_MODE } from "../store/enums.js";
import { testBonus } from "../store/testConst.js";
import {
  setBonusCurrency,
  setCashback,
  setFirstDeposit,
  setForUser,
  setFreeSpins,
  setRegistration,
  setStartBot,
  setWelcome
} from "../store/promotionsSlice.js";
import { API_CASINO } from "../api/casino.js";
import { dispatchCusEvent } from "../utils/utils.js";
import { ENUM_TAWK_API } from "./other/useTawkController.js";
import useBalance from "./useBalance.js";

const DELAY_GET_INFO = 1 * 1000;

export default function useFillUser() {
  const userId = useAppSelector((state) => state.user.userId);
  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";
  const isAuth = useAppSelector((state) => state.user.isAuth);
  const currency = useAppSelector((state) => state.user.currency);
  const currencyDefault = useAppSelector((state) => state.common.currencyDefault);
  const { mainBalance } = useBalance();

  const dispatch = useDispatch();

  const bonusTmRef = useRef();

  const getInfo = () => {
    if (TEST_MODE) return;
    if (!userId) return;

    API_USER.getProfile()
      .then((e) => {
        dispatch(setInfo(e.data));

        if (e.data.email) {
          dispatchCusEvent(ENUM_TAWK_API.visitor, { name: "", email: e.data.email });
        } else if (e.data.telegramName) {
          dispatchCusEvent(ENUM_TAWK_API.visitor, {
            name: e.data.telegramName,
            email: ""
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getBonus = async () => {
    if (TEST_MODE) {
      const data = testBonus;
      dispatch(setBonusCurrency(data.currency));
      dispatch(setCashback(data.cashback));
      dispatch(setFirstDeposit(data.firstDeposit));
      dispatch(setRegistration(data.registration));
      dispatch(setStartBot(data.startBot));
      dispatch(setWelcome(data.welcome));
      return;
    }

    await API_CASINO.bonus
      .get({ start_r, currency })
      .then((e) => {
        const data = e.data;
        const bonuses = data.bonuses;

        dispatch(setBonusCurrency(data.currency));
        dispatch(setFirstDeposit(data.firstDeposit));
        dispatch(setRegistration(data.registration));
        dispatch(setForUser(userId));
        dispatch(setStartBot(data.startBot));
        if (bonuses) {
          dispatch(setWelcome(bonuses.welcome));
          dispatch(setCashback(bonuses.cashback));
          dispatch(setFreeSpins(bonuses.freespin));
        }
      })
      .catch((e) => {
        console.log(e);
        dispatch(setForUser(ENUM_PROMOTION_STATUS.error));
      });
    // dispatch(setForUser(ENUM_PROMOTION_STATUS.error));
  };

  useEventListener(ENUM_COMMON_EVENT.getInfo, () => getInfo());
  useEventListener(ENUM_COMMON_EVENT.getBonus, (e) => {
    const { successFn } = e.detail || {};

    clearTimeout(bonusTmRef.current);
    bonusTmRef.current = setTimeout(async () => {
      await getBonus();
      successFn?.();
    }, DELAY_GET_INFO);
  });

  useEffect(() => {
    getInfo();
  }, [userId]);

  useEffect(() => {
    if (!currency) return;

    dispatchCusEvent(ENUM_COMMON_EVENT.getBonus);
  }, [isAuth, userId, currency, start_r, mainBalance]);

  useEffect(() => {
    if (!isAuth && currencyDefault) dispatch(setCurrency(currencyDefault));
  }, [isAuth, currencyDefault]);
}
